import { Typography } from '@cobliteam/ui/components';
import Icon from '@cobliteam/ui/icons';

import insightsLogo from '../../assets/insightsLogo.webp';

const LandingContent = () => {
  return (
    <div className='flex flex-col items-center justify-center gap-8 py-8'>
      <div className='flex flex-col items-center gap-6 text-center'>
        <div className='flex size-20 items-center justify-center rounded-2xl bg-gradient-to-br from-primary-2 to-primary-3'>
          <img src={insightsLogo} alt='Cobli IA Insights' className='size-12' />
        </div>
        <div className='flex flex-col gap-2'>
          <Typography variant='heading-3xl' as='h1' className='text-gray-12'>
            Insights Cobli IA
          </Typography>
          <Typography variant='text-md' color='secondary' className='max-w-lg text-gray-9'>
            Inteligência artificial que transforma dados da sua frota em ações práticas
          </Typography>
        </div>
      </div>

      <div className='flex w-full max-w-2xl flex-col gap-6'>
        <div className='flex gap-4 rounded-lg border border-gray-4 bg-gray-1 p-5'>
          <div className='flex size-10 shrink-0 items-center justify-center rounded-lg bg-primary-3'>
            <Icon name='lightbulb' color='primary' className='size-5' />
          </div>
          <div className='flex flex-col gap-2'>
            <Typography variant='text-md-semibold' color='secondary'>
              O que são os Insights?
            </Typography>
            <Typography variant='text-sm' color='secondary' className='text-gray-11 leading-relaxed'>
              Os insights gerados pela inteligência artificial da Cobli utilizam os dados relativos ao desempenho da sua frota para notificar sobre aspectos relevantes que merecem
              receber a sua atenção.
            </Typography>
          </div>
        </div>

        <div className='flex gap-4 rounded-lg border border-gray-4 bg-gray-1 p-5'>
          <div className='flex size-10 shrink-0 items-center justify-center rounded-lg bg-primary-3'>
            <Icon name='calendar' color='primary' className='size-5' />
          </div>
          <div className='flex flex-col gap-2'>
            <Typography variant='text-md-semibold' color='secondary'>
              Frequência
            </Typography>
            <Typography variant='text-sm' color='secondary' className='text-gray-11 leading-relaxed'>
              Cinco insights serão gerados semanalmente sobre assuntos relativos à semana anterior. Você pode conferir os insights na página inicial do seu painel ou na seção
              dedicada à inteligência artificial da Cobli na barra de navegação superior.
            </Typography>
          </div>
        </div>

        <div className='flex gap-4 rounded-lg border border-primary-4 bg-primary-1 p-5'>
          <div className='flex size-10 shrink-0 items-center justify-center rounded-lg bg-primary-3'>
            <Icon name='arrow-right' color='primary' className='size-5' />
          </div>
          <div className='flex flex-col gap-2'>
            <Typography variant='text-md-semibold' color='secondary'>
              Como começar?
            </Typography>
            <Typography variant='text-sm' color='secondary' className='text-gray-11 leading-relaxed'>
              Clique nos insights ao lado esquerdo para conferir insights novos e passados.
            </Typography>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingContent;
